"use client";
import Script from "next/script";
import { initializeLogger } from ".";

const homepagePaths = new Set(["/", "/es", "/fr"]);

export const FeLoggerClient = ({
  subscriptionKey,
  src,
}: {
  subscriptionKey: string;
  src: string;
}) => (
  <Script
    onReady={() => {
      initializeLogger({
        subscriptionKey,
        ...(homepagePaths.has(document.location.pathname) && {
          additionalData: {
            homepage: "DotNext",
          },
        }),
      })();
    }}
    src={src}
  />
);
